import { isRuntimeCoreLoginEnabled } from '../config/featureFlags';
import ClassicLoginPage from './ClassicLoginPage';
import RuntimeCoreLogin from './RuntimeCoreLogin';

export default function Login() {
  if (isRuntimeCoreLoginEnabled()) {
    return <RuntimeCoreLogin />;
  }

  return <ClassicLoginPage />;
}
